module.exports = __webpack_public_path__ + "media/images/etiqa_dropdown-6dc30fdf834a816f23f9091436a9a7a0.jpg";